import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Users, Receipt, BarChart3, LogOut, Leaf, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/associados", label: "Associados", icon: Users, id: "associados" },
  { to: "/admin/mensalidades", label: "Mensalidades", icon: Receipt, id: "mensalidades" },
  { to: "/admin/relatorios", label: "Relatórios", icon: BarChart3, id: "relatorios" },
];

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
    isActive ? "bg-white text-[#052E16]" : "text-emerald-100 hover:bg-white/10 hover:text-white"
  }`;

export function AdminHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-neutral-600 mt-1">{subtitle}</p>}
      </div>
      <div className="flex gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  async function doLogout() {
    await logout();
    nav("/admin/login");
  }

  return (
    <div className="min-h-screen bg-[#F6F8F6] md:flex text-[#052E16]" data-testid="admin-shell">
      <aside className="md:w-64 md:h-screen md:sticky md:top-0 bg-[#052E16] text-white flex flex-col">
        <div className="px-5 py-4 md:py-6 flex items-center gap-2 border-b border-white/10">
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-emerald-400/15 text-emerald-300">
            <Leaf className="w-5 h-5" />
          </span>
          <span className="font-display font-extrabold leading-none">
            Ressignificar
            <span className="block text-[10px] tracking-[0.2em] text-emerald-300 mt-1">PAINEL ADMIN</span>
          </span>
        </div>
        <nav className="flex md:flex-col gap-1 p-3 overflow-x-auto md:flex-1">
          {links.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink key={to} to={to} end={end} className={linkCls} data-testid={`admin-nav-${id}`}>
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
          <button
            onClick={doLogout}
            className="md:hidden flex items-center gap-2 px-3 py-2.5 text-sm text-emerald-100"
            data-testid="admin-logout-mobile"
          >
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </nav>
        <div className="hidden md:block p-4 border-t border-white/10 space-y-3">
          <p className="text-xs text-emerald-200 truncate" data-testid="admin-user-email">{user?.email}</p>
          <button
            onClick={doLogout}
            className="flex items-center gap-2 text-sm text-white hover:text-emerald-300"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" /> Sair
          </button>
          <Link to="/" className="flex items-center gap-2 text-xs text-emerald-200 hover:text-white" data-testid="admin-view-site">
            <ExternalLink className="w-3.5 h-3.5" /> Ver site público
          </Link>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-5 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
